export default {
  // List page
  pageTitle: 'Air-Ground Integrated Collaborative Inspection Tasks',
  taskName: 'Task Name',
  wayLineJobId: 'Wayline Job ID',
  dogTaskId: 'Robot Dog Task ID',
  createTime: 'Create Time',
  operation: 'Operation',
  viewReport: 'View Report',
  fetchTaskListFailed: 'Failed to fetch task list',

  // Detail page
  detailTitle: 'Air-Ground Integrated Collaborative Inspection Report',
  breadcrumbInspection: 'Collaborative Inspection',
  breadcrumbReport: 'Report',

  // Card titles
  section1Title: '1. Statistics Overview',
  section2Title: '2. Robot Dog Inspection Task',
  section3Title: '3. Drone Inspection Task',
  section4Title: '4. Robot Dog Inspection Content and Results',
  section5Title: '5. Drone Inspection Content and Results',
  section6Title: '6. Comprehensive Conclusion',

  // Statistics overview
  totalCount: 'Total Detection Count',
  detectionTypes: 'Detection Types',
  abnormalHeatSourceCount: 'Abnormal Heat Source Count',
  stackedObjectCount: 'Stacked Object Count',
  vehicleViolationCount: 'Vehicle Violation Count',
  unit: '',
  unitType: '',

  // Task information
  taskNameLabel: 'Task Name',
  executionTime: 'Execution Time',

  // Table columns
  category: 'Category',
  subItem: 'Sub-item',
  standard: 'Standard/Requirement',
  result: 'Result',
  remarks: 'Issues/Suggestions',

  // Inspection items
  stackedObject: 'Stacked Objects',
  stackedObjectCheck: 'Stacked Objects Check Around Passage and Equipment',
  stackedObjectStandard: 'No stacked objects around passage and equipment, keep clear',
  abnormalHeatSource: 'Abnormal Heat Source',
  smokeDetection: 'Smoke Detection',
  smokeDetectionStandard: 'No smoke, normal air quality',
  fireDetection: 'Fire Detection',
  fireDetectionStandard: 'No fire, normal temperature',
  vehicleViolation: 'Vehicle Violation',
  vehicleViolationCheck: 'Vehicle Check in Fire Lane and No-Parking Zones',
  vehicleViolationStandard: 'No illegal parking in fire lanes and no-parking zones',

  // Inspection results
  qualified: 'Qualified',
  unqualified: 'Unqualified',
  attention: 'Attention',

  // Inspection result descriptions
  stackedObjectQualified: 'No stacked objects found, passage is clear and meets requirements.',
  stackedObjectUnqualified: 'Detected {count} stacked object location(s). It is recommended to clean them promptly to keep the passage clear.',
  smokeQualified: 'No smoke detected, meets requirements.',
  smokeUnqualified: 'Detected smoke at {count} location(s). It is recommended to immediately investigate the source of smoke to ensure safety.',
  fireQualified: 'No fire detected, meets requirements.',
  fireUnqualified: 'Detected fire at {count} location(s). Immediate action is recommended to ensure safety.',
  vehicleViolationQualified: 'No vehicle violations found. Parking management is standardized and meets requirements.',
  vehicleViolationUnqualified: 'Detected vehicle violations at {count} location(s). It is recommended to contact the vehicle owners to move the vehicles and keep fire lanes clear.',

  // Alarms
  dogAlarmDetails: 'Robot Dog Alarm Details',
  flightAlarmDetails: 'Drone Alarm Details',
  totalAlarms: 'Total {count} Alarms',
  alarmType: 'Alarm Type',
  alarmDetail: 'Details',
  position: 'Position',
  detectionTime: 'Detection Time',
  sceneImage: 'Scene Image',

  // Alarm types
  alarmFire: 'Abnormal Heat Source',
  alarmSmoke: 'Smoke',
  alarmBox: 'Stacked Objects',
  alarmMeter: 'Meter Reading',
  alarmViolation: 'Vehicle Violation',

  // Empty states
  dogInspectionNoIssue: 'Robot dog inspection completed, no issues found',
  flightInspectionNoIssue: 'Drone inspection completed, no issues found',

  // Comprehensive conclusion
  conclusionHasIssues: 'The following issues were found during this air-ground integrated collaborative inspection:',
  conclusionNoIssue: 'The air-ground integrated collaborative inspection was completed successfully. No abnormalities were found and all inspection indicators meet requirements.',
  unqualifiedItem: '{count} unqualified item(s)',
  riskPoint: '{count} risk point(s)',
  alarmItem: '{count} alarm(s)',
  conclusionSuggestion: '. Please implement corrective measures promptly according to the recommendations and track the progress.',

  // Error messages
  missingParameters: 'Missing required parameters',
  fetchReportFailed: 'Failed to fetch report data',
  fetchDogAlarmFailed: 'Failed to fetch robot dog alarm data',
  fetchFlightAlarmFailed: 'Failed to fetch drone alarm data',
}
